import HardBreak from '@tiptap/extension-hard-break';
import { normalizeNewlinesInDoc } from './normalize-newlines-in-doc.util';

// Extension that normalizes newline tokens only at initialization - it converts any newline-like tokens in the incoming HTML into <br> tags.
export const NewlineImportNormalizer = HardBreak.extend({
  name: 'newlineImportNormalizer',
  onCreate() {
    const original = this.editor.getJSON();
    const transformed = normalizeNewlinesInDoc(original);
    // Only update if something actually changed
    if (JSON.stringify(transformed) !== JSON.stringify(original)) {
      this.editor.commands.setContent(transformed, false);
    }
  },
});
